import type { ConfigMap } from './custom-app-config-schema';

export const customConstants: ConfigMap = {
  "psi": {
    "tenant": {
      "id": "dcfc373c-0870-4a88-88c3-4a706de51463",
      "name": "PSI"
    },
    "supportEmail": "ptsupport@psionline.com",
    "companyName": "PSI",
    "app": {
      "id": "2c183c41-6dc0-4ef4-837c-0eb0f86a61b1",
      "name": "PSI Test Prep",
      "scheme": "psi.memorang",
      "mobile": {
        "apple": {
          "teamId": "373QDA7ZL7",
          "ascIssuerId": "69a6de87-66ae-47e3-e053-5b8c7c11a4d1",
          "ascKeyId": "W8JZ8MAV65",
          "ascApiKeyP8": "887d925b-948a-41b5-884f-69d791700129",
          "ascAppId": "1565909858"
        },
        "android": {
          "versionCode": 124,
          "package": "com.memorang.psi.insurance.testprep",
          "googleServicesJson": "c4e1d731-8e5a-4d9a-a6c0-694c2117e1a7",
          "serviceAccountJson": "a1550366-e1a7-4044-869f-73e2ec6997e2"
        },
        "ios": {
          "bundleIdentifier": "com.memorang.psi.insurance",
          "buildNumberState": {
            "currentVersion": "2.1.24",
            "buildNumber": 8
          }
        }
      },
      "version": "2.1.25",
      "maintenance": {
        "enabled": true,
        "title": "We'll be right back",
        "urls": {
          "ios": "https://apps.apple.com/us/app/psi-test-prep/id1565909858",
          "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en_IN"
        },
        "subtitle": "We are currently making improvements to enhance your experience. The PSI app is temporarily unavailable due to maintenance. We apologize for any inconvenience and appreciate your patience. Once maintenance is complete, the current version of the app will no longer be supported. 👉 If you are on mobile, please update to the latest version of the app from the App Store or Google Play Store to continue using it."
      },
      "font": "beausite",
      "trademark": "PSI",
      "showDiagnostic": true,
      "showPracticeTests": true,
      "masteryLevels": [
        {
          "id": "low",
          "darkColor": "rgba(212, 84, 84, 1)",
          "lightColor": "rgba(191, 0, 0, 1)",
          "sortOrder": 6,
          "icon": "speedometer-slow",
          "range": {
            "type": "formative",
            "score": [
              0,
              39
            ],
            "points": [
              0,
              6
            ]
          },
          "alias": {
            "title": "Incorrect"
          },
          "level": "low"
        },
        {
          "id": "medium",
          "darkColor": "rgba(181, 77, 33, 1)",
          "lightColor": "rgba(255, 143, 96, 1)",
          "sortOrder": 3,
          "icon": "speedometer-medium",
          "range": {
            "type": "formative",
            "score": [
              40,
              59
            ],
            "points": [
              7,
              12
            ]
          },
          "alias": {
            "title": "Almost there"
          },
          "level": "low"
        },
        {
          "id": "high",
          "darkColor": "rgba(82, 167, 141, 1)",
          "lightColor": "rgba(0, 129, 89, 1)",
          "sortOrder": 1,
          "icon": "speedometer",
          "range": {
            "type": "formative",
            "score": [
              80,
              100
            ],
            "points": [
              17,
              30
            ]
          },
          "alias": {
            "title": "Mastered"
          },
          "level": "high"
        }
      ],
      "scoreRanges": [
        {
          "rangeArray": [
            0,
            74
          ],
          "range": "0-74",
          "color": "#d66565",
          "icon": "emoticon-sad-outline"
        },
        {
          "rangeArray": [
            75,
            84
          ],
          "range": "75-84",
          "color": "#dda53a",
          "icon": "emoticon-neutral-outline"
        },
        {
          "rangeArray": [
            85,
            100
          ],
          "range": "85-100",
          "color": "#66bb68",
          "icon": "emoticon-happy-outline"
        }
      ],
      "fontSizes": {
        "stem": 16,
        "answer": 16
      },
      "analytics": {
        "mixpanel": {
          "id": "e2354d451161a9deacf641952f49ab00"
        }
      },
      "logo": {
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/icon.png",
        "adaptiveIcon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/adaptive-icon.png",
        "stacked": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_light.png?t=2024-09-11T02%3A52%3A07.652Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_stacked_dark.png?t=2024-09-11T02%3A52%3A21.053Z"
          }
        },
        "default": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_light.png?t=2024-09-11T02%3A52%3A32.632Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/app_logo_dark.png?t=2024-09-11T02%3A52%3A42.516Z"
          }
        },
        "company": {
          "light": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_light.png?t=2024-09-11T02%3A53%3A01.928Z"
          },
          "dark": {
            "uri": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/icons/company_logo_dark.png?t=2024-09-11T02%3A52%3A51.342Z"
          }
        }
      },
      "links": {
        "baseUrl": "https://app.psiexams.com",
        "privacy": "https://app.psiexams.com/legal/privacy",
        "tos": "https://app.psiexams.com/legal/terms",
        "ios": "https://apps.apple.com/in/app/psi-test-prep/id1565909858",
        "android": "https://play.google.com/store/apps/details?id=com.memorang.psi.insurance.testprep&hl=en&gl=US",
        "redeemSupportUrl": "https://app.psiexams.com/legal/privacy",
        "companyUrl": "https://www.psiexams.com/en-gb/"
      },
      "keys": {
        "revenueCat": {
          "ios": "appl_tfbBxQbsoZLVyISjLSZWoccqCzi",
          "android": "goog_xnLVKZpZmlknMbzVJXNOLTdigye"
        },
        "oneSignalAppId": "67d6088f-0bcd-4d04-9984-b5f8efa0dcfc",
        "clerk": {
          "publishableKeyDev": "pk_test_Z2FtZS1saW9uZXNzLTgyLmNsZXJrLmFjY291bnRzLmRldiQ",
          "publishableKeyProd": "pk_live_Y2xlcmsuYXBwLnBzaWV4YW1zLmNvbSQ"
        }
      },
      "integrations": {
        "slack": {
          "channel": "#memorang-psi-shared"
        }
      },
      "tagType": {
        "en-US": "topic"
      },
      "aiAssistant": {
        "title": "Ai Learning Agent",
        "alias": "AiLA",
        "icon": "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/partners/psi/assistant/assistant_dark.png?t=2024-09-20T04%3A10%3A34.686Z",
        "showOriginalQuestion": true,
        "initialMessage": "👋 Hey there, I'm the **{{alias}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
        "initialAiMessage": {
          "en-US": "👋 Hey there, I'm the **{{alias}}**, your {{title}}, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the question you answered about **{{topic}}.**",
          "ja-JP": "👋 こんにちは、**{{alias}}** です。{{title}}として、**{{context}}**の準備をサポートします！**{{topic}}**についての質問について詳しく見ていきましょう。",
          "zh-CN": "👋 你好，我是 **{{alias}}**, 你的 {{title}}, 我在这里帮助你更好地准备 **{{context}}!** 让我们特别深入探讨一下你回答的问题 **{{topic}}.**"
        }
      },
      "isImageChallengeApp": false,
      "isStudyPackEnabled": true,
      "landing": {
        "title": {
          "prefix": "The",
          "decoratedText": "official",
          "suffix": "AI app for PSI Test Prep"
        },
        "marketText": {
          "prefix": "Start for free",
          "suffix": "with a diagnostic"
        },
        "valueProps": [
          {
            "icon": "book-open-page-variant-outline",
            "title": "Official Practice",
            "subtitle": "400+ items authored by the official PSI team"
          },
          {
            "icon": "head-snowflake-outline",
            "title": "Personalised AI Coach",
            "subtitle": "Real-time, AI-powered grading, feedback, and tutoring"
          },
          {
            "icon": "web",
            "title": "Study Anywhere",
            "subtitle": "Study on the web or download the iPhone and Android apps"
          }
        ],
        "landingGraphics": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/psi/icons/landing_graphics.png"
      },
      "showCountrySelection": false,
      "sessionConfig": {
        "showDistributionFilters": true,
        "maxItemsPerSession": 50,
        "showItemsSlider": true,
        "showLearningMode": true
      },
      "accountSettings": {
        "showCurrentExam": true,
        "showPartnersSection": true
      },
      "deployments": {
        "autoDeploymentEnabled": false,
        "web": {
          "pendingDeployment": null,
          "lastDeployment": {
            "id": "dpl_HA9vDrCuGTgjovGMhmp6oXDCvPiu",
            "deployedAt": "2025-12-10T06:47:03.327Z",
            "version": "2.1.24"
          }
        }
      }
    },
    "groupByCategory": null,
    "exam": {
      "enabled": true,
      "quizEnabled": true,
      "allowChangeExam": true,
      "practiceTest": {
        "header": {
          "title": "Practice Tests",
          "subtitle": "Take practice tests to assess your exam readiness, strengths, and opportunities for improvement"
        },
        "label": "Practice Tests",
        "summativeTestAlertConfig": {
          "quiz": {
            "description": "Start with a short, free diagnostic to familiarize yourself with the test format.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "practiceTest": {
            "description": "Assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "clipboard-text-outline",
            "severity": "info"
          },
          "quizAndPracticeTest": {
            "description": "Start with a free diagnostic to familiarize yourself with the test format or assess your readiness with timed, full-length practice tests. Get detailed explanations, personalized feedback, and a score report after you finish.",
            "icon": "format-list-checks",
            "severity": "info"
          },
          "topicMastery": {
            "description": "The table below shows your performance on each topic, the number of items you've answered so far, the proportion of the exam that the topic represents, and your opportunity for improvement. The greater the 'opportunity,' the better suited you will be by focusing your studies to strengthen your mastery of that topic to maximize your chance of passing.",
            "icon": "chart-line",
            "severity": "info",
            "title": "Mastery Breakdown"
          }
        },
        "enabled": {
          "mobile": false,
          "web": true
        },
        "deviceRecommendationDialog": {
          "enabled": false,
          "title": "Best experience on laptop",
          "message": "For the best experience, we recommend taking practice tests on a laptop or desktop computer."
        }
      },
      "examDateDisclaimer": "This date is only to guide your study schedule within the app. It does not affect your official exam registration."
    },
    "store": {
      "enabled": true
    },
    "homeView": {
      "showRecommendedChallenge": false,
      "showArticles": false,
      "showChallengeOfTheWeek": false,
      "masterySubheaderLabel": "Subject Mastery"
    },
    "showStudyPackAsHome": null,
    "reportView": {
      "practiceTest": {
        "reviewEnabled": true
      },
      "stats": [
        {
          "type": "correct",
          "title": "Correct",
          "icon": "checkbox-marked-circle-outline",
          "tooltip": "How many questions you've answered"
        },
        {
          "type": "accuracy",
          "title": "Accuracy",
          "icon": "radar",
          "tooltip": "How many questions you've answered correctly"
        },
        {
          "type": "duration",
          "title": "Duration",
          "icon": "timer-outline",
          "tooltip": "How long you took to complete the test"
        },
        {
          "type": "avgSpeed",
          "title": "AVG SPEED",
          "icon": "speedometer",
          "tooltip": "How long you took to answer each question"
        },
        {
          "type": "hintsUsed",
          "title": "Hints used",
          "icon": "lightbulb-on-outline",
          "tooltip": "Number of hints used in this session"
        },
        {
          "type": "pointsEarned",
          "title": "Points Earned",
          "icon": "star-outline"
        }
      ],
      "cards": [
        {
          "type": "session-mastery",
          "title": {
            "en-US": "Session mastery"
          }
        },
        {
          "type": "tag-mastery",
          "title": {
            "en-US": "Topics"
          }
        },
        {
          "type": "item-review",
          "title": {
            "en-US": "Item review"
          }
        }
      ],
      "formative": {
        "maxScore": 100,
        "reviewEnabled": true
      }
    },
    "onboarding": [
      {
        "step": "chooseCategory",
        "enabled": true,
        "title": "Choose Category",
        "description": "onboarding.steps.chooseCategory.description"
      },
      {
        "step": "chooseContext",
        "enabled": true,
        "title": "Choose your Exam",
        "description": "onboarding.steps.chooseContext.description"
      },
      {
        "step": "examDate",
        "enabled": false,
        "title": "Choose your Exam Date",
        "description": "onboarding.steps.testDate.description"
      }
    ],
    "navigation": {
      "routes": {
        "main": [
          {
            "title": "Home",
            "name": "home",
            "icon": {
              "default": "home-outline",
              "selected": "home"
            },
            "enabled": true,
            "custom": false
          },
          {
            "title": "Podcasts",
            "name": "podcasts",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Podcasts",
            "name": "study-pack",
            "icon": {
              "default": "book-open-page-variant-outline",
              "selected": "book-open-page-variant"
            },
            "enabled": false
          },
          {
            "title": "Study Guides",
            "name": "study-guides",
            "icon": {
              "default": "note-multiple",
              "selected": "note-multiple-outline"
            },
            "enabled": false
          },
          {
            "title": "Progress",
            "name": "progress",
            "icon": {
              "default": "chart-timeline-variant-shimmer",
              "selected": "chart-line-variant"
            },
            "enabled": true
          },
          {
            "title": "Leaders",
            "name": "leaderboard",
            "icon": {
              "default": "trophy-outline",
              "selected": "trophy"
            },
            "enabled": true
          },
          {
            "title": "Store",
            "name": "store",
            "icon": {
              "default": "cart-outline",
              "selected": "cart"
            },
            "enabled": true
          },
          {
            "title": "Articles",
            "name": "(articles)/articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Articles",
            "name": "articles",
            "icon": {
              "default": "file-document-multiple-outline",
              "selected": "file-document-multiple"
            },
            "enabled": false
          },
          {
            "title": "Challenges",
            "name": "challenges",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          },
          {
            "title": "More",
            "name": "more",
            "icon": {
              "default": "menu",
              "selected": "microsoft-xbox-controller-menu"
            },
            "enabled": true
          },
          {
            "title": "Challenges",
            "name": "library",
            "icon": {
              "default": "arm-flex-outline",
              "selected": "arm-flex"
            },
            "enabled": false
          }
        ]
      }
    },
    "sessionView": null,
    "theme": {
      "colors": {
        "dark": {
          "error": "rgb(255, 180, 171)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "neutral": "rgba(116, 120, 119, 1)",
          "onError": "rgb(105, 0, 5)",
          "outline": "rgb(141, 145, 153)",
          "primary": "rgb(93, 212, 252)",
          "surface": "#1A212B",
          "backdrop": "rgba(44, 49, 55, 0.4)",
          "tertiary": "rgb(191, 207, 96)",
          "elevation": {
            "level0": "transparent",
            "level1": "#1C242E",
            "level2": "#1A212B",
            "level3": "#1E2631",
            "level4": "#202934",
            "level5": "#222B37"
          },
          "onPrimary": "rgb(0, 0, 0)",
          "onSurface": "#FFFFFF",
          "secondary": "#CEBAAB",
          "background": "rgb(25, 28, 29)",
          "onTertiary": "rgb(45, 52, 0)",
          "onSecondary": "#103D4B",
          "onBackground": "rgb(225, 227, 228)",
          "errorContainer": "rgb(147, 0, 10)",
          "inversePrimary": "rgb(20, 96, 165)",
          "inverseSurface": "rgb(227, 226, 230)",
          "outlineVariant": "rgb(67, 71, 78)",
          "surfaceVariant": "rgb(67, 71, 78)",
          "surfaceDisabled": "rgba(227, 226, 230, 0.12)",
          "inverseOnSurface": "rgb(47, 48, 51)",
          "onErrorContainer": "rgb(255, 180, 171)",
          "onSurfaceVariant": "rgb(195, 198, 207)",
          "primaryContainer": "rgb(0, 72, 129)",
          "onSurfaceDisabled": "rgba(227, 226, 230, 0.38)",
          "tertiaryContainer": "rgb(66, 75, 0)",
          "onPrimaryContainer": "rgb(211, 228, 255)",
          "secondaryContainer": "#103D4B",
          "onTertiaryContainer": "rgb(219, 236, 121)",
          "onSecondaryContainer": "#F2E9D8"
        },
        "light": {
          "error": "rgb(186, 26, 26)",
          "scrim": "rgb(0, 0, 0)",
          "shadow": "rgb(0, 0, 0)",
          "onError": "rgb(255, 255, 255)",
          "outline": "rgb(112, 120, 124)",
          "primary": "#103D4B",
          "surface": "rgb(251, 252, 254)",
          "backdrop": "rgba(42, 50, 53, 0.4)",
          "tertiary": "rgb(88, 100, 0)",
          "elevation": {
            "level0": "transparent",
            "level1": "rgb(238, 245, 248)",
            "level2": "rgb(231, 240, 244)",
            "level3": "rgb(223, 236, 240)",
            "level4": "rgb(221, 234, 239)",
            "level5": "rgb(216, 231, 236)"
          },
          "onPrimary": "#F2E9D8",
          "onSurface": "rgb(25, 28, 29)",
          "secondary": "#BC5221",
          "background": "rgb(251, 252, 254)",
          "onTertiary": "rgb(255, 255, 255)",
          "onSecondary": "#fff",
          "onBackground": "rgb(25, 28, 29)",
          "errorContainer": "rgb(255, 218, 214)",
          "inversePrimary": "rgb(93, 212, 252)",
          "inverseSurface": "rgb(46, 49, 50)",
          "outlineVariant": "rgb(191, 200, 204)",
          "surfaceVariant": "rgb(220, 228, 232)",
          "surfaceDisabled": "rgba(25, 28, 29, 0.12)",
          "inverseOnSurface": "rgb(239, 241, 242)",
          "onErrorContainer": "rgb(65, 0, 2)",
          "onSurfaceVariant": "rgb(64, 72, 76)",
          "primaryContainer": "rgb(184, 234, 255)",
          "onSurfaceDisabled": "rgba(25, 28, 29, 0.38)",
          "tertiaryContainer": "rgb(219, 236, 121)",
          "onPrimaryContainer": "rgb(0, 31, 40)",
          "secondaryContainer": "#F2E9D8",
          "onTertiaryContainer": "rgb(25, 30, 0)",
          "onSecondaryContainer": "#1A212B"
        }
      }
    }
  }
} as unknown as ConfigMap;